import React, { useEffect, useState, useContext } from 'react';
import Routes from '../../Routes';
import Footer from './Footer';
import NavMenu from './NavMenu';
import { SettingsContext } from '../../contexts/SettingsContext';

function Layout() {

    const { isAdmin } = useContext(SettingsContext);

    useEffect(() => {
    }, [isAdmin]);

    return (
        <div className="app">
            <NavMenu />
            <div className="site-content" id="site-content">
                <div id="container-content" style={{ height: "100%", width: "100%" }}>
                    <Routes />
                </div>
            </div>
            <div className="site-footer">
                <Footer />
            </div>
        </div>
    );
}

export default Layout;